export default __webpack_public_path__ + "static/media/KZ.T.08.2370.5c96514c.svg";